import axios from 'axios'
import { BASE_URL } from '../ApiService/ApiConfig.js';

let token = localStorage.getItem('jwt');
if (token) {
    token = token.replaceAll('"', '');
}

let config = {
    headers: {
        'Content-Type': "application/json",
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Authorization': 'Bearer ' + token
    }

}

export class UbicacionesService {


    async guardarTarjeta(tarjeta) {

        return await axios.post(`${BASE_URL}/maestro/tarjeta`, { data: tarjeta }, config).then(res => res.data.data);
    }

    async getListaTarjetas() {

        return await axios.get(`${BASE_URL}/maestro/tarjeta/estado/Activo` ,
            config
        ).then(res => res.data.data);
    }

    async getListaUbicaciones() {

        return await axios.get(`${BASE_URL}/ubicacion/estado/Activo`,
            config
        ).then(res => res.data.data);
    }

    async getListaTipoUbicaciones() {

        return await axios.get(`${BASE_URL}/configuracion/configuracion-det/configuracion-cab/codigo/UBI-0000-0000`,
            config
        ).then(res => res.data.data);
    }

    async getListaTipoTarjeta() {

        return await axios.get(`${BASE_URL}/configuracion/configuracion-det/configuracion-cab/codigo/TAR-0000-0000`,
            config
        ).then(res => res.data.data);
    }

    async getListaUbicacionesPorIdyEstado(_ubicacionId) {

        return await axios.get(`${BASE_URL}/ubicacion/`  + _ubicacionId + '/estado/Activo',
            config
        ).then(res => res.data.data);
    }

    async guardarUbicacion(ubicacion) {
        return await axios.post(`${BASE_URL}/ubicacion`, { data: ubicacion }, config).then(res => res.data)
    }

}

